import { tv } from '@change/ds-utils';

export const SkeletonContainerStyles = tv({
	base: 'flex flex-row items-center justify-start',
	variants: {
		size: {
			xsmall: 'h-full w-full',
			small: 'gap-0.5 p-[5px]',
			medium: 'gap-1 p-2.5',
			large: 'gap-1.5 p-3',
		},
	},
});

export const RectangleShapeStyles = tv({
	base: '',
	variants: {
		size: {
			xsmall: 'h-full',
			small: 'h-[3px]',
			medium: 'h-1.5',
			large: 'h-2',
		},
	},
});
